import '../base.js';
import RESEARCH_CURRENT from './research.current.data.js';
import RESEARCH_PAST from './research.past.data.js';

document.addEventListener('DOMContentLoaded', function onLoaded() {
  document.removeEventListener('DOMContentLoaded', onLoaded);
  let container = document.getElementById('svl-current-research--article-container');
  for (const research of RESEARCH_CURRENT) {
    const researchEl = document.createElement('article');
    researchEl.classList.add('columns', 'is-desktop');
    const leftEl = document.createElement('div');
    leftEl.classList.add('column', 'is-one-quarter');
    leftEl.innerHTML = `
      <figure class="image">
        <img src="../${research.image}"
             alt="Research">
      </figure>
    `;
    const rightEl = document.createElement('div');
    rightEl.classList.add('column');
    const rightTitleEl = document.createElement('p')
    rightTitleEl.classList.add('title', 'is-5');
    rightTitleEl.innerText = research.title;
    rightEl.appendChild(rightTitleEl);
    const rightContentEl = document.createElement('div')
    rightContentEl.innerHTML = research.content;
    rightEl.appendChild(rightContentEl);
    
    researchEl.appendChild(leftEl);
    researchEl.appendChild(rightEl);
    
    container.appendChild(researchEl);
  }
  container = document.getElementById('svl-past-research--article-container');
  for (const research of RESEARCH_PAST) {
    const researchEl = document.createElement('article');
    researchEl.classList.add('columns', 'is-desktop');
    const leftEl = document.createElement('div');
    leftEl.classList.add('column', 'is-one-quarter');
    leftEl.innerHTML = `
      <figure class="image">
        <img src="../${research.image}"
             alt="Research">
      </figure>
    `;
    const rightEl = document.createElement('div');
    rightEl.classList.add('column');
    const rightTitleEl = document.createElement('p')
    rightTitleEl.classList.add('title', 'is-5');
    rightTitleEl.innerText = research.title;
    rightEl.appendChild(rightTitleEl);
    const rightContentEl = document.createElement('div')
    rightContentEl.innerHTML = research.content;
    rightEl.appendChild(rightContentEl);
    
    researchEl.appendChild(leftEl);
    researchEl.appendChild(rightEl);
    
    container.appendChild(researchEl);
  }
});
